var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markup"},[_c('div',{staticClass:"markup__subtitle markup__subtitle_head"},[_vm._v("ТТ Формат Pre-banner (статичное изображение/анимация в видеоплеере)")]),_c('banners-article')],1)}
var staticRenderFns = []

export { render, staticRenderFns }